import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { formatPrice } from 'common/formatters';

import SrCard from 'client/components/SrCard/SrCard';

import './SrUnderwrittenRentComparisonCard.less';

const SrUnderwrittenRentComparisonCard = ({ listing }) => {
  return (
    <SrCard padding="18px 12px 12px" maxWidth="100%" styleName="srCard">
      <span styleName="cardTitle">Underwritten Rent comparison</span>
      <div styleName="cards">
        <div styleName="card yellow">
          <span styleName="title">Underwritten Rent</span>
          <span styleName="number yellow">{formatPrice(listing.underwrittenRent)}</span>
        </div>
        <div
          styleName={classnames('card', {
            green: listing.price >= listing.underwrittenRent,
            orange: listing.price < listing.underwrittenRent,
          })}
        >
          <span styleName="title">Current Price</span>
          <span styleName="number green">{formatPrice(listing.price)}</span>
        </div>
      </div>
    </SrCard>
  );
};

SrUnderwrittenRentComparisonCard.propTypes = {
  listing: PropTypes.object.isRequired,
};

SrUnderwrittenRentComparisonCard.displayName = 'SrUnderwrittenRentComparisonCard';

export default SrUnderwrittenRentComparisonCard;
